import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

class Role {
  create = async (details: any) => {
    const response = await axios
      .post<any>(`${API_URL}role`, details)
      .catch((e) => {
        throw e.message;
      });
    return response.data;
  };

  edit = async (details: any, code: any) => {
    await axios.put<any>(`${API_URL}role/${code}`, details).catch((e) => {
      const { message } = e.response.data;
      if (message.errorInfo) throw message.errorInfo[2];
      else throw e.message;
    });
  };

  get = async (code: any) => {
    const response = await axios
      .get<any>(`${API_URL}role/${code}`)
      .catch((e) => {
        throw e.message;
      });
    return response.data.role;
  };

  getAll = async () => {
    const response = await axios.get<any>(`${API_URL}role`).catch((e) => {
      throw e.message;
    });
    return response.data.role;
  };
}
export default new Role();